module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bg-c88bc1149cfff55226012c4f1b1326b8.png";